import { render } from "./EquipmentPageComponent.vue?vue&type=template&id=389ce2f7"
import script from "./EquipmentPageComponent.vue?vue&type=script&lang=js"
export * from "./EquipmentPageComponent.vue?vue&type=script&lang=js"

import "./EquipmentPageComponent.vue?vue&type=style&index=0&id=389ce2f7&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__